import activities from './activities';
import status from './status';

const index = {
  activities,
  status,
};

export default index;